import React from 'react';
import './PaymentTableSkeleton.css';

const PaymentTableSkeleton = () => {
  return (
    <div className="payment-table-skeleton-wrapper">
      <table className="payment-table-skeleton">
        <thead>
          <tr>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
            <th className="payment-skeleton-th">
              <div className="payment-skeleton-header" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(8)].map((_, index) => (
            <tr key={index} className="payment-skeleton-row">
              <td>
                <div className="payment-skeleton-cell" />
              </td>
              <td>
                <div className="payment-skeleton-cell-long" />
              </td>
              <td>
                <div className="payment-skeleton-badge" />
              </td>
              <td>
                <div className="payment-skeleton-cell" />
              </td>
              <td>
                <div className="payment-skeleton-cell" />
              </td>
              <td>
                <div className="payment-skeleton-cell" />
              </td>
              <td>
                <div className="payment-skeleton-cell" />
              </td>
              <td>
                <div className="payment-skeleton-badge" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentTableSkeleton;
